import React from "react";

import { Box, Card, Group, LoadingOverlay, Text } from "@mantine/core";

import { ExplorerSortDropdown } from "components/ExplorerSearchContainer/ExplorerSortDropdown";
import { useIsLoadingSearchData } from "hooks/routing";
import { TitleExplorerCompanyRollup } from "lib/frontend/benchmarking/types";

import { TitlePageResultsAccordion } from "./TitlePageResultsAccordion";
import { ExplorerPaginationControls } from "../ExplorerResultsPagination";

interface TitlePageResultsProps {
  results: TitleExplorerCompanyRollup[];
  offset: number;
  numResultsOnPage: number;
  numTotalResults: number;
}

export function TitlePageResultsCard(props: TitlePageResultsProps): JSX.Element {
  const loading = useIsLoadingSearchData();
  const showNoResults = props.numTotalResults === 0 && !loading;

  return (
    <Box
      pos="relative"
      sx={{
        borderRadius: "0px",
        borderTop: `1px solid var(--mantine-color-gray-3)`,

        "@media (max-width: var(--mantine-breakpoint-xs))": {
          borderLeft: 0,
          borderRight: 0,
          borderRadius: 0,
        },
      }}
    >
      <>
        <Card.Section p={16}>
          <LoadingOverlay
            visible={loading}
            overlayProps={{
              blur: 1,
            }}
            zIndex={80}
            loaderProps={{
              sx: {
                position: "absolute",
                top: 125,
              },
            }}
          />

          <Group justify="space-between" sx={{ alignItems: "center" }}>
            <Text fz={18} fw={600} lh={"28px"} c="gray.8">
              Data Points
            </Text>
            <Box display={{ base: "none", lg: "flex" }}>
              <ExplorerSortDropdown />
            </Box>
          </Group>
        </Card.Section>

        {!showNoResults && (
          <>
            <Card.Section withBorder p={16}>
              <TitlePageResultsAccordion results={props.results} />
            </Card.Section>
            <Card.Section py="8px">
              <ExplorerPaginationControls
                resultsLength={props.numResultsOnPage}
                numTotalResults={props.numTotalResults}
                resultsOffset={props.offset}
              />
            </Card.Section>
          </>
        )}
      </>
    </Box>
  );
}
